import { Image, Page, Text, View } from '@react-pdf/renderer';
import ZillowMoodys from '../../img/ZillowMoodys.png';
import ParkBackground from '../../img/ParkBackground.jpeg';
import { BuildingsIcon } from '../../img/BuildingsIcon';
import { AdproductsMoodysReportType } from '@zg-rentals/ts-customer-analytics-client';

interface CoverPageProps {
  quarter: string;
  year: number;
  submarketName: string;
  marketName: string;
  reportType: AdproductsMoodysReportType;
  isPremium?: boolean;
}

export const getReportNameString = ({
  hasSubmarketData,
  isPremium,
}: {
  hasSubmarketData: boolean;
  isPremium?: boolean;
}) => {
  const reportLabel = isPremium ? 'Advanced' : 'Basic';
  return `Moody’s ${reportLabel} ${hasSubmarketData ? 'Subm' : 'M'}arket Report`;
};

export const CoverPage = ({ quarter, year, submarketName, marketName, reportType, isPremium }: CoverPageProps) => {
  const hasSubmarketData = reportType === AdproductsMoodysReportType.SUBMARKET;
  const marketReportString = getReportNameString({ isPremium, hasSubmarketData });

  return (
    <Page
      size="LETTER"
      style={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#001751',
        justifyContent: 'space-between',
        position: 'relative',
      }}
    >
      <View style={{ height: 'auto', width: '100%' }}>
        <Image style={{ objectFit: 'scale-down', zIndex: -999 }} src={ParkBackground as typeof ZillowMoodys} />
      </View>
      <View
        style={{
          height: '100px',
          width: '100%',
          backgroundColor: '#001751',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: 250,
          }}
        >
          <View style={{ margin: 15, textAlign: 'left' }}>
            <Image style={{ objectFit: 'scale-down' }} src={ZillowMoodys} />
          </View>
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingRight: 20,
          }}
        >
          <View>
            <Text style={{ fontFamily: 'OpenSans', color: 'white', fontSize: 8 }}>DATA AS OF</Text>
            <Text style={{ fontFamily: 'OpenSansBold', color: 'white', fontSize: 12 }}>{`${quarter} ${year}`}</Text>
          </View>
        </View>
      </View>
      <View
        style={{
          position: 'absolute',
          top: '550px',
          left: '0px',
          width: '500px',
          padding: '20px',
          backgroundColor: 'white',
          color: '#0C4599',
        }}
      >
        <View
          style={{
            border: '2px solid #0C4599',
            padding: '5px',
            borderRadius: '30px',
            width: '230px',
          }}
        >
          <Text style={{ fontFamily: 'OpenSans', fontSize: 12, textAlign: 'center' }}>{marketReportString}</Text>
        </View>
        <Text style={{ fontFamily: 'OpenSansBold', fontSize: 30 }}>
          {hasSubmarketData ? submarketName : marketName}
        </Text>
        {hasSubmarketData && (
          <View style={{ display: 'flex', flexDirection: 'row' }}>
            <View
              style={{
                height: '14px',
                marginLeft: '-12px',
                marginRight: '-8px',
                marginTop: '1px',
              }}
            >
              <BuildingsIcon />
            </View>
            <Text style={{ fontFamily: 'OpenSans', fontSize: 14 }}>{marketName}</Text>
          </View>
        )}
      </View>
    </Page>
  );
};
